import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
    styles: {
        global: {
            body: {
                bg: 'gray.50',
            },
        },
    },
    components: {
        Button: {
            defaultProps: {
                colorScheme: 'blue',
            },
        },
        Container: {
            baseStyle: {
                maxW: 'container.xl',
            },
        },
        Heading: {
            baseStyle: {
                fontWeight: 'bold',
            },
        },
    },
})

export default theme